import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  SelectListSingle,
  Alert
} from '@/common'
import { useTranslation } from 'react-i18next'
import { StoredCO2Handling } from '@/features/production-routes/api/ProductionRouteModel'
import { useCallback, useState } from 'react'
import { StepFooter } from '@/shared/components'

export default function ProductionRouteStoredCO2({
  next,
  previous,
  initialValue
}: {
  next: (payload: { storedCO2Handling: StoredCO2Handling }) => void
  previous: () => void
  initialValue: StoredCO2Handling | null
}) {
  const { t } = useTranslation()

  const [storedCO2Handling, setStoredCO2Handling] = useState<null | StoredCO2Handling>(initialValue)

  const onPreviousClick = useCallback(() => {
    previous()
  }, [previous])

  const onChange = useCallback(
    (value: StoredCO2Handling) => {
      setStoredCO2Handling(value)
    },
    [setStoredCO2Handling]
  )

  const onNextClick = useCallback(() => {
    if (storedCO2Handling === null) {
      return
    }
    next({
      storedCO2Handling
    })
  }, [storedCO2Handling, next])

  const isNextButtonEnabled = storedCO2Handling !== null

  const options = Object.values(StoredCO2Handling).map(value => {
    const callout =
      value !== StoredCO2Handling.None
        ? t(`productionRoute:storedCO2.options.${value}.description`)
        : null
    const hasCallout = !!callout
    const isChecked = value === storedCO2Handling
    return {
      id: value,
      label: t(`productionRoute:storedCO2.options.${value}.title`),
      value,
      children: callout ? (
        <Alert type="info" sizeType="sm">
          {callout}
        </Alert>
      ) : null,
      isChecked,
      isOpen: hasCallout && isChecked
    }
  })

  return (
    <div className="space-y-4">
      <Card>
        <CardHeader>
          <CardTitle title={t('productionRoute:storedCO2.title')} />
        </CardHeader>
        <CardBody className="space-y-4">
          <Alert type="info" className="whitespace-pre-line">
            {t(`productionRoute:storedCO2.info`)}
          </Alert>
          <SelectListSingle<StoredCO2Handling>
            className="space-y-2"
            items={options}
            name="storedCO2"
            onChange={onChange}
          />
        </CardBody>
      </Card>
      <StepFooter
        onPrevious={onPreviousClick}
        onNext={onNextClick}
        isNextEnabled={isNextButtonEnabled}
      />
    </div>
  )
}
